module.exports = __webpack_public_path__ + "files/a0d806c435f3d14d687a362d1ee90d70.svg";